import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface RecoverAnalysisDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    translations: {
        title: string;
        question: string;
        cancel: string;
        confirm: string;
    };
}

const RecoverAnalysisDialog: React.FC<RecoverAnalysisDialogProps> = ({
    open,
    onCancel,
    onConfirm,
    translations
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="recover-analysis-dialog-title"
            aria-describedby="recover-analysis-dialog-description"
        >
            <DialogTitle id="recover-analysis-dialog-title">
                {translations.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="recover-analysis-dialog-description">
                    {translations.question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {translations.cancel}
                </Button>
                <Button onClick={onConfirm} color="warning" variant="contained">
                    {translations.confirm}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RecoverAnalysisDialog;
